export const handleUnflat = (arr: any[], count: number) => {
    const result = [];
    for (let s = 0, e = count; s < arr.length; s += count, e += count)
        result.push(arr.slice(s, e));
    return result;
}
